import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Toast } from 'antd-mobile-v5'
import { useIntl } from 'react-intl'
import {
  freeFirstCardItems,
  getPostageFromCatalog,
  hasPaidPhysicalItem,
  resolveCartItemNo,
} from '../../pages/BuyCards/cardOptionUtils'
import { getEcards, getRedeemedFreeCards } from '../../reducers/selectors'
import { useEcardGoods } from '../../services/hooks'
import EcardCheckoutPopup from './EcardCheckoutPopup'

import styles from './Cart.module.scss'

const CartFooter = ({ toggleCheckAll, checkedList, shoppingCart, valueAdded, cardOptions }) => {
  const { formatMessage } = useIntl()
  const [showCheckout, setShowCheckout] = useState(false)
  // 商品目录：历史购物车条目（持久化旧数据）缺 itemNo，结算时按卡面现匹配补上
  const { data: goodsCatalog } = useEcardGoods()
  // 免费首卡资格（与服务端归零口径一致）：总计扣除该卡目录价，避免总计 198、实付 99 的误导；
  // 已下单/已兑证书（redeemedFreeCards）不再扣减（按 99 计）
  const { ecards, redeemedFreeCards } = useSelector((state) => ({
    ecards: getEcards(state),
    redeemedFreeCards: getRedeemedFreeCards(state),
  }))

  const checkout = () => {
    // CHNA-2618：增值服务（实体卡85折/周边8折）不能单独购买，必须搭配至少一个已选卡面的卡
    if (!checkedList.length && valueAdded.length === 0) return
    if (valueAdded.length > 0 && !checkedList.length) {
      Toast.show({ content: formatMessage({ id: 'ecard-rights-requires-card' }) })
      return
    }
    setShowCheckout(true)
  }

  const getFormatItems = () => {
    let formatCheckedList = []
    checkedList.forEach((item1) => {
      // checkedList 与 shoppingCart 同源（均为 GET shopCart 响应条目），按 (ecardId, itemNo) 关联
      const checkedItem = shoppingCart.find((item2) => item1.ecardId === item2.ecardId && item1.itemNo === item2.itemNo)
      if (checkedItem) {
        // 历史购物车条目无 itemNo（本地持久化旧数据）→ 按卡面+卡类型从 ecard_goods 目录匹配，
        // 匹配逻辑抽到 resolveCartItemNo（与 BuyCards 立即购买下单逻辑一致）
        formatCheckedList.push({
          ...checkedItem,
          itemNo: resolveCartItemNo(goodsCatalog, cardOptions, checkedItem),
        })
      }
    })
    return formatCheckedList
  }

  const getAddedPrice = () => {
    let price = 0
    valueAdded.map((i) => {
      price = price + i.price
    })
    return price * 100
  }

  const totalPrice = () => {
    // 免费首卡：服务端按证书归零（一张证书一次），一单可有多张（2026-09-17 取消「每单限 1 张」），
    // 故按全部命中条目扣减目录价；同证书重复明细只算首条（与后端归零口径一致）
    const freeItems = freeFirstCardItems(checkedList, ecards, redeemedFreeCards)
    // 运费取目录 EXPRESS_FEE 商品价（后端维护），与确认订单弹窗同口径；
    // 运费口径（2026-09-16 起、2026-09-17 收紧）：只有「整单没有付费实体卡」的免费首卡单收运费
    // ——付费实体卡价已含运费、两张卡一个快递寄出，同车即包邮
    const postage = getPostageFromCatalog(
      goodsCatalog,
      getFormatItems().map((item) => item.itemNo),
      freeItems.length,
      hasPaidPhysicalItem(checkedList, ecards, redeemedFreeCards)
    )
    const freeDeduction = freeItems.reduce((sum, item) => sum + (Number(item.price) || 0), 0)
    return (
      (checkedList.reduce((total, current) => total + current.price, 0) -
        freeDeduction +
        getAddedPrice() +
        postage * 100) /
      100
    )
  }

  return (
    <>
      <div className={styles['cart-footer']}>
        <div className={styles.left}>
          <div
            className={checkedList.length === shoppingCart.length ? styles.checked : styles['not-checked']}
            onClick={toggleCheckAll}
          >
            {checkedList.length === shoppingCart.length && (
              <img src={require('../../assets/images/buy_cards/check-circle.png')} alt="checked" />
            )}
          </div>
          <div className={styles['checked-all']}>全选</div>
          <div className={styles['price-wrapper']}>
            <div className={styles.text}>总计</div>
            <div className={styles['price-box']}>
              <span className={styles['price-symbol']}>￥</span>
              <span className={styles.price}>{totalPrice().toFixed(2)}</span>
            </div>
          </div>
        </div>
        <div
          className={checkedList.length > 0 ? styles.right : styles['right-disable']}
          onClick={checkout}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            // 键盘可达性：Enter/Space 触发结算
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              checkout()
            }
          }}
        >
          去结算
        </div>
      </div>
      <EcardCheckoutPopup
        visible={showCheckout}
        setVisible={setShowCheckout}
        items={getFormatItems()}
        valueAdded={valueAdded}
      />
    </>
  )
}

export default CartFooter
